/* eslint-disable no-undef */
// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const usersApi = createApi({
  reducerPath: "usersApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_URL + "/api/user",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set("x-access-token", `${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    signin: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "signin",
      }),
    }),
    signinStudent: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "signinStudent",
      }),
    }),
    incrementStudentNumberOfLogins: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "incrementStudentNumberOfLogins",
      }),
    }),
    forgetPassword: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "forgetPassword",
      }),
    }),
    updatePassword: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "updatePassword",
      }),
    }),
    changePassword: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "changePassword",
      }),
    }),
    resetPassword: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "resetPassword",
      }),
    }),
    createRespUni: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "createRespUni",
      }),
    }),
    registerRespUni: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "registerRespUni",
      }),
    }),
    createAgentUni: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "createAgentUni",
      }),
    }),
    registerAgentUni: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "registerAgentUni",
      }),
    }),
    loginStudents: builder.mutation({
      query: (data) => ({
        body: data,
        method: "POST",
        url: "signinStudent",
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useSigninMutation,
  useForgetPasswordMutation,
  useUpdatePasswordMutation,
  useCreateRespUniMutation,
  useRegisterRespUniMutation,
  useCreateAgentUniMutation,
  useRegisterAgentUniMutation,
  useChangePasswordMutation,
  useLoginStudentsMutation,
  useResetPasswordMutation,
  useIncrementStudentNumberOfLoginsMutation,
} = usersApi;
